var map = {
	"./Examples/FunctionalComponents.mdx": 1598,
	"./Examples/MicroFrontend.mdx": 8533,
	"./Examples/RemoteComponents.mdx": 5967,
	"./Examples/SimpleExample.mdx": 7743,
	"./GettingStarted/Installation.mdx": 2358,
	"./GettingStarted/JxmlFile.mdx": 5294,
	"./GettingStarted/Runtime.mdx": 1053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1991;